import { molecule } from "bunshi"
import { LoggerScope } from "./logger-scope"

export const LoggerMolecule = molecule((_, scope) => {
  const faro = scope(LoggerScope)

  return faro
})
